export default __webpack_public_path__ + "static/media/client7.52aa210c.png";